export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4731.85152c42.jpg";